module.exports = __webpack_public_path__ + "static/img/young_emissary1.c79ff23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/young_emissary1.png
// module id = Icq7
// module chunks = 0